export const getTranslationColor = (color: string): string => {
  return `"color: ${color};"`;
};

export const getTranslationFontStyle = (fontStyle: string): string => {
  return `"font-style: ${fontStyle};"`;
};
